export default {
      id: "yt-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#yt-usage",
      toString: function () {
        return this.url;
      }
    }